s<template>

  <div class="wrapper">
    
    <Rating v-if="modal.rating" @closeModal="() => modal = { rating: false }" />

    <Ended v-if="modal.ended" />

    <v-row v-if="isLoading" no-gutters class="py-12 px-12" justify="center" align="center" style="height: 100%">
      <v-progress-circular size="32" width="2.5" indeterminate></v-progress-circular>
    </v-row>
      
    <div class="video-area">
      <vue-jitsi-meet v-if="validRoom" ref="jitsiRef" domain="meet.bsibr.com" :options="jitsiOptions"/>
    </div>

  </div>
</template>

<script>

import Ended from "@/components/ended";
import Rating from "@/components/rating";

import { JitsiMeet } from '@mycure/vue-jitsi-meet';

export default {
    name: "Room",
    components: {
      Ended,
      Rating,
      VueJitsiMeet: JitsiMeet
    },
    data: () => ({
      users: [],
      modal: { ended: false, rating: false },
      messages: [],
      validRoom: false,
      isLoading: true,
      jitsiOptions: {}
    }),
    mounted(){
      const { roomID } = this.$route.params;
      const atendimentoID = Number(roomID);
      this.$socket.emit("atendimentos_find", { atendimentoID });
      this.$socket.emit("rooms_join", { atendimentoID });
    },
    sockets:{
      atendimentos_finish: function({error}){
        this.validRoom = false;
        if(!error) this.modal = { rating: true };
      },
      atendimentos_find: function({error, payload}){

        this.isLoading = false;

        if(!error && !payload.end_at) {
          this.validRoom = true;
          this.initiJitsi(payload.id);
        }else{
          this.modal = { ended: true };
        }
        
      }
    },

    methods:{
      async initiJitsi(atendimentoID){

        const localData = JSON.parse(localStorage.getItem('@bsi:user'));

        this.jitsiOptions = {
          roomName: `bsi-vendas-${atendimentoID}`,
          userInfo: {
            displayName: localData.nome,
          },
          configOverwrite: {
            enableNoisyMicDetection: false,
            disableDeepLinking: true
          },
        }

      },
      async addTrack(track) {

        const { jitsi: { room } } = this;
        const type = track.getType();
        const ownerID = track.getParticipantId();
        const localID = room.myUserId();

        const name = room.participants[ownerID] && room.participants[ownerID]._displayName;

        const index = this.users.findIndex(value => value.jitsiID === ownerID);

        if(index === -1 && name) {

          this.users.push({name, jitsiID: ownerID});
          await this.$nextTick();

          return;
        }else{
          this.$set(this.users, index, {...this.users[index], [type]: track });
        }

        console.log(this.users);

      },
      onIFrameLoad () {
        console.log("sadasd")
      }
    },
}
</script>

<style lang="css">
  .video-area iframe .desktop-browser{
    display: none !important;
  }
</style>

<style lang="scss" scoped>

  .wrapper{
    overflow: hidden;
    height: 95vh;
    border-radius: 12px;
    width: 400px;
    // background: url(https://www.desktopbackground.org/download/720x1280/2012/11/11/481872_one-lonely-person-wallpapers-bing-images_1920x1440_h.jpg);
    background-size: 100% 100%;

    .end-call{
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 26px;
      cursor: pointer;
      z-index: 2;
    }

    .fade{
      height: 100%;
      display: flex;
      flex-direction: column;
      width: 100%;
      background: rgb(2,0,36);
      background: linear-gradient(0deg, rgba(2,0,36,1) 0%, rgba(0,0,0,1) 0%, rgba(9,9,121,0) 30%, rgba(9,9,121,0) 100%);
    }

    .video-area{
      display: flex;
      flex-direction: column;
      height: 100%;
      // height: calc(100% - 50px);
    }
    
    .waiting{

      width: 25vw;
      min-width: 300px;
      display: block;
      padding: 40px 20px;

      .name{
        color: var(--v-primary-base);
        font-weight: bold;
      }
      h3{
        font-size: 26px;
        font-weight: 400;
        text-align: center;
      }
      p{
        font-size: 14px;
        text-align: center;
        padding: 20px 0;
      }
      .loading{
        display: block;
        margin: 0 auto;
      }
      img{
        display: block;
        margin-top: 20px;
        margin-left: auto;
      }

    }

    @media only screen and (max-width: 480px) {
      
      .wrapper{
        height: 100vh;
        width: 100vw;
        border-radius: 0;
      }
    
    }
   
  }

</style>